import '../styles/main.scss';

import React from 'react';

interface JobProps {
  range: string;
  position: string;
  location: string;
  format: 'in-office' | 'remote' | 'hybrid';
  desciption: string;
}

const Job: React.FunctionComponent<JobProps> = ({
  position,
  range,
  desciption,
  location,
  format,
}) => {
  return (
    <div>
      <h5>
        {position} | {range}
      </h5>
      <h5>
        {location} | {format}
      </h5>
      <p>{desciption}</p>
    </div>
  );
};

export default Job;
